import axios from 'axios';
import { toast } from 'react-toastify';
import { apiUrl } from '../config/apiUrl';

/** Headers for the /outlook routes, which act on the signed-in user's own Outlook. */
export const outlookAuth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

/** Ask the backend (signed in) for the Microsoft sign-in link, then go there. */
export async function startOutlookLogin(token) {
  try {
    const res = await axios.get(`${apiUrl}/outlook/login-url`, outlookAuth(token));
    if (!res?.data?.url) throw new Error('No sign-in link');
    window.location.href = res.data.url;
  } catch (e) {
    toast.error('Could not start Outlook sign-in. Please try again.');
  }
}

/**
 * Whether this user's Outlook is connected lives on the server; the flag in the browser
 * resets at every login, so a connected person was shown "Connect Outlook" (and a second
 * connect could hang). Ask the server once per login and set the flag from its answer.
 */
let checkedFor = '';
export async function syncOutlookStatus(token, dispatch, setOutlookAuthenticated) {
  if (!token || checkedFor === token) return;
  checkedFor = token;
  try {
    const res = await axios.get(`${apiUrl}/outlook/status`, outlookAuth(token));
    dispatch(setOutlookAuthenticated(res?.data?.hasValidToken === true));
  } catch (e) {
    checkedFor = '';
  }
}
